// Local translations
export const T = {
  en_GB: {
    htmlCode: "HTML Code",
    codeTab: "Code",
    placeholder:
      '<div id="widget"></div>\n<script src="https://cdn.jsdelivr.net/npm/example-widget/dist/widget.js"></script>',
    helpText:
      "Paste HTML (scripts allowed, loaded from jsDelivr, unpkg or cdnjs). It always runs in an isolated sandbox. To show a YouTube video, a form or another web page, use the Web page (URL) component instead.",
    warning:
      "Warning: Only embed content from trusted sources. Malicious HTML can compromise security.",
    generateWithAi: "Build with AI",
    promptPlaceholder:
      "A loan affordability calculator: income, existing debt and interest rate in, monthly capacity out",
    promptHelp: "Describe the widget. It is generated in the app's design and replaces the HTML.",
    generate: "Generate",
    regenerate: "Regenerate",
    generating: "Generating…",
    preview: "Preview",
    previewEmpty: "Nothing to preview yet",
    generated: "Widget generated",
    failed: "Could not generate the widget",
    promptRequired: "Describe what you want first",
  },
  nb_NO: {
    htmlCode: "HTML-kode",
    codeTab: "Kode",
    placeholder:
      '<div id="widget"></div>\n<script src="https://cdn.jsdelivr.net/npm/example-widget/dist/widget.js"></script>',
    helpText:
      "Lim inn HTML (skript er tillatt, lastet fra jsDelivr, unpkg eller cdnjs). Den kjører alltid i en isolert sandkasse. For å vise en YouTube-video, et skjema eller en annen nettside, bruk komponenten Nettside (URL) i stedet.",
    warning:
      "Advarsel: Bygg kun inn innhold fra pålitelige kilder. Ondsinnet HTML kan kompromittere sikkerheten.",
    generateWithAi: "Lag med AI",
    promptPlaceholder:
      "En lånekalkulator: inntekt, eksisterende gjeld og rente inn, månedlig kapasitet ut",
    promptHelp: "Beskriv widgeten. Den lages i appens design og erstatter HTML-koden.",
    generate: "Generer",
    regenerate: "Generer på nytt",
    generating: "Genererer…",
    preview: "Forhåndsvisning",
    previewEmpty: "Ingenting å forhåndsvise ennå",
    generated: "Widget generert",
    failed: "Kunne ikke generere widgeten",
    promptRequired: "Beskriv hva du vil ha først",
  },
} as const;
